<template>
  <div class="filter-bar">
    <slot/>
    <a href="#" class="filter-bar__clear" v-if="active" @click.prevent="$emit('clear')">Limpar filtros</a>
  </div>
</template>

<script>
/**
 * Faixa de filtros acima das tabelas de Avisos e Campanhas e Liberacoes. Os
 * campos vem pelo slot, em ate 5, e a ORDEM decide a coluna: datas, depois os
 * dois seletores do meio, depois o que fica sozinho na terceira coluna.
 * "Limpar filtros" so aparece com algum filtro ligado.
 */
export default {
  name: 'filter-bar',
  props: {
    active: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
/* Grade de 3 colunas x 2 linhas preenchida coluna a coluna: os campos entram
   na ordem do slot (1-2 na primeira coluna, 3-4 na segunda, 5 na terceira) e
   "Limpar filtros" cai embaixo do quinto. Cada coluna tem a largura dos
   proprios campos. */
.filter-bar {
  display: grid;
  grid-template-rows: auto auto;
  grid-auto-flow: column;
  grid-auto-columns: max-content;
  align-items: end;
  gap: 12px 24px;
  margin-bottom: 16px;
}
.filter-bar__clear { justify-self: start; padding-bottom: 8px; font-size: 12px; color: #1b59f8; }
@media (max-width: 767px) {
  .filter-bar { grid-template-rows: none; grid-auto-flow: row; grid-auto-columns: auto; }
}
.filter-bar__clear:hover,
.filter-bar__clear:focus { color: #1b59f8; text-decoration: underline; }
</style>



// WEBPACK FOOTER //
// src/vue/pages/components/default/filterBar.vue